export const langData: any = {
  ja: {
    message: {
      globalNav: {
        reflection: "計算式反映",
        calc: "デバッグ",
        scenario: "シナリオ",
        paperSize: "用紙",
        printer: "印刷",
        coater: "表面加工",
        dieCut: "打ち抜き",
        glue: "貼り",
        custom: "カスタム",
        option: "オプション",
        other: "その他"
      },
      paginator: {
        totalHead: "全",
        totalTail: "件"
      },
      reflection: {
        confirmation:
          "変更内容が見積画面に即時反映されます。\n反映してもよろしいですか？",
        completed: "反映しました。",
        wait: "お待ちください"
      },
      editCommon: {
        save: "保存する",
        saveAndBack: "保存して戻る",
        new: "新規作成",
        saveConfirmation: "データを上書きしてよろしいですか？",
        deleteConfirmation: "削除しても良いですか?",
        beforeUnload:
          "保存していないデータは失われます。\n移動してよろしいですか？",
        yes: "はい",
        no: "いいえ",
        cancel: "キャンセル",
        cause: "入力エラーの原因",
        error: {
          invalidSheetValue: "Sheet Valueの順番が正しくありません。",
          invalidCost: "Costの値が正しくありません。",
          unauthorized: "Emailまたはパスワードが正しくありません。",
          error: "エラー",
          loginExpired:
            "ログイン期限が切れました、再びログイン操作を行って下さい。"
        }
      },
      login: {
        h1: "管理ツール",
        loginButton: "ログイン",
        logout: "ログアウト",
        saveEmail: "Emailとパスワードをブラウザに保存する"
      },
      scenario: {
        h1: "シナリオリスト",
        addScenario: "アイテム追加",
        routeMap: "ルートマップ",
        edit: "編集",
        delete: "削除",
        activate: "使用する",
        deactivate: "使用しない",
        copy: "シナリオをコピー",
        copied: "コピーしました。",
        copyConfirmation: "コピーしても良いですか?"
      },
      scenarioEdit: {
        h1: "シナリオ編集",
        h1New: "新規シナリオ",
        scenarioName: "名前",
        paperSize: "用紙サイズ",
        imposition: "面付け",
        displayMethod: "カテゴリ",
        holderCalcType: "提げ手計算タイプ",
        printer: "印刷",
        coater: "表面加工",
        dieCut: "打ち抜き",
        gluer: "貼り",
        custom: "カスタム",
        margin: "マージン",
        noUpperLimit: "上限なし",
        limitTo: "上限",
        woodenModalCalcSkip: "木型費用",
        packingCostCalcSkip: "梱包費用",
        yes: "計算飛ばさない",
        no: "計算飛ばす",
        alertNoPaperSize: "用紙が設定されていません",
        linkSettingPaperSize: "用紙を設定する",
        linkSettingDieCut: "打ち抜きを設定する",
        linkSettingGluer: "貼りを設定する",
        linkSettingCoater: "表面加工を設定する",
        linkSettingCustom: "カスタムを設定する",
        alertNoCoater: "表面加工が設定されていません",
        thMargin: {
          deliveryTime: "納期",
          fixedCost: "固定",
          rate: "率"
        },
        error: {
          enterScenarioName: "名前を入力してください。",
          noCoater: "表面加工が設定されていません。",
          noPaperSize: "用紙が設定されていません。",
          noDieCut: "打ち抜きが設定されていません。",
          noGlue: "貼りが設定されていません。",
          noCustom: "カスタムが設定されていません。",
          unselectedCoater: "は用紙に設定されていません。"
        },
        success: "更新しました。"
      },
      diecut: {
        h1: "打ち抜き",
        add: "アイテム追加",
        thName: "名前",
        thEdit: "編集",
        thDelete: "削除",
        thInfo: "使用状況",
        thCostType: "コストタイプ",
        edit: "編集",
        delete: "削除",
        deleteConfirmation: "削除してもよろしいですか?",
        infoFront: "つのシナリオで使用中",
        infoRear: ""
      },
      dieCutEdit: {
        h1: "名前",
        h2: "コストタイプ",
        dieCutCost: "コスト",
        minimumCost: "ミニマムコスト",
        runningCost: "Running Cost",
        costPerHour: "コスト／時",
        preparationTime: "準備時間 (分)",
        productivityHead: "スピード",
        productivity: "通し数／時",
        costTypeA: "固定コスト",
        costTypeB: "ミニマムコスト",
        costPerSheet: "枚あたりコスト",
        sheetVolume: "通し数",
        cost: "単価",
        error: {
          enterDieCutName: "打ち抜き名を入力してください。",
          tooLargeValue: "値が大き過ぎます。"
        }
      },
      optionEdit: {
        h1: "オプション",
        foilStamping: "箔押し",
        colorAdjustment: "色彩調整",
        sample: "サンプル",
        shareOnWeb: "Web掲載",
        keepWoodenMold: "抜き型保存",
        existingWoodenMold: "前回抜き型",
        thOption: "オプション",
        thCostPerMm: "コスト／㎟",
        thFixedCost: "固定コスト",
        thCost: "コスト",
        thUpperDiscountCost: "値引き上限"
      },
      otherEdit: {
        h1: "その他",
        packingParams: "梱包費用",
        weightAllowance: "箱あたり最大重量(kg)",
        materialCost: "梱包コスト／箱",
        packingCosts: "梱包オプション費用",
        deliveryCosts: "配送料",
        otherCosts: "その他",
        cutterLengthCosts: "形状別木型コスト",
        paperBugHolderCosts: "提げ手コスト",
        settingsRounding: "四捨五入",
        settingsFixedWoodenMoldCost: "木型固定コスト",
        settingsTaxVat: "消費税",
        thPackingParams: "paramater",
        thPackingFee: "オプション",
        thPackingFeeCostPerPack: "コスト／梱包",
        thPackingOption: "エリア",
        thPackingCostPerPack: "送料／箱",
        thOther: "その他",
        thBoxShape: "形状",
        thcoefficientPricePercm: "コスト／cm",
        thUnitA: "単価A",
        thUnitB: "単価B",
        thRounding: "単位"
      },
      custom: {
        h1: "カスタム",
        add: "アイテム追加",
        thName: "名前",
        thEdit: "編集",
        thDelete: "削除",
        thInfo: "使用状況",
        thCostType: "コストタイプ",
        edit: "編集",
        delete: "削除",
        infoFront: "つのシナリオで使用中",
        infoRear: ""
      },
      customEdit: {
        customName: "名前",
        description: "説明",
        costType: "コストタイプ",
        costTypeFixed: "固定コスト",
        costTypeMinimum: "ミニマムコスト",
        thFixedCost: "固定コスト",
        thMinimumCost: "ミニマムコスト",
        selectUnit: "単位",
        buffer: "コスト",
        thVolume: "量",
        thUnitCost: "単価 ",
        margin: "マージン",
        unitLabels: {
          quantity: "個数",
          sheet: "通し数",
          impression: "印刷ページ",
          areaSize: "面積(cm2)",
          imposition: "面付け"
        },
        marginLabels: {
          notApply: "適用しない",
          apply: "適用する"
        }
      },
      paperSize: {
        h1: "用紙",
        add: "アイテム追加",
        thName: "用紙",
        thWidth: "幅 W",
        thDimension: "奥行 D",
        thUnprintable: "",
        thUnprintableWidth: "印刷不可領域 W",
        thUnprintableDimension: "印刷不可領域 D",
        thInfo: "使用状況",
        thCoaterInfo: "表面加工",
        edit: "編集",
        delete: "削除",
        infoFront: "つのシナリオで使用中",
        infoRear: "",
        infoCoaterUsed: "設定済み",
        infoCoaterUnused: "未設定"
      },
      paperCost: {
        h2: "一枚当たりのコスト",
        paperType: "用紙名",
        fixedCost: "固定コスト"
      },
      glue: {
        h1: "貼り",
        add: "アイテム追加",
        thName: "名前",
        thEdit: "編集",
        thDelete: "削除",
        thInfo: "使用状況",
        thCostType: "コストタイプ",
        edit: "編集",
        delete: "削除",
        infoFront: "つのシナリオで使用中",
        infoRear: ""
      },
      glueEdit: {
        h1: "名前",
        h2: "コストタイプ",
        glueCost: "固定コスト",
        minimumCost: "ミニマムコスト",
        runningCost: "1個あたりコスト",
        runningFixFormCost: "定型1個あたりコスト",
        costPerHour: "コスト／時",
        preparationTime: "準備時間 (分)",
        productivityBS: "形状別スピード",
        machineBoxUnitCost: "紙袋形状別単価",
        thBoxShape: "形状",
        thQuantity: "個数／時",
        thUnitCost: "単価 ",
        costTypeA: "固定コスト",
        costTypeB: "ミニマムコスト",
        sheetVolume: "数量",
        cost: "コスト",
        error: {
          enterGlueName: "貼り名を入力してください。",
          tooLargeValue: "値が大き過ぎます。"
        }
      },
      printer: {
        h1: "印刷",
        add: "アイテム追加",
        thName: "名前",
        thEdit: "編集",
        thDelete: "削除",
        thInfo: "使用状況",
        thCostType: "コストタイプ",
        edit: "編集",
        delete: "削除",
        infoFront: "つのシナリオで使用中",
        infoRear: ""
      },
      printerEdit: {
        h1: "名前",
        costType: "コストタイプ",
        fixedCost: "固定コスト",
        costTypeA: "固定コスト(Inkjet)",
        costTypeB: "固定コスト(トナー)",
        costTypeC: "ミニマムコスト",
        sheetVolume: "通し数",
        thCost: "コスト／時",
        thPreparationTIme: "準備時間(分)",
        buffer: "予備",
        printSpeed: "印刷スピード",
        thPrintSpeed: "通し数／時",
        inkCost: "インク代",
        thCostForMaxSize: "コスト(最大サイズ)",
        thMaxSizeW: "最大サイズ W",
        thMaxSizeD: "最大サイズ D",
        proofing: "校正コスト",
        threeDWeb: "3D Web",
        actualProofing: "実物校正",
        cost: "コスト",
        minimumCost: "ミニマムコスト",
        plateCost: "版コスト",
        ctp: "コスト／版",
        printCost: "枚あたり印刷コスト／色",
        costPerSheet: "Cost per Sheet / Color",
        costPerImpression: "ページあたりコスト",
        unitCost: "単価",
        error: {
          enterDieCutName: "Enter the Name.",
          tooLargeValue: "Too Large Value."
        }
      },
      coater: {
        h1: "表面加工",
        add: "アイテム追加",
        thName: "名前",
        thEdit: "編集",
        thDelete: "削除",
        thInfo: "使用状況",
        thCostType: "コストタイプ",
        edit: "編集",
        delete: "削除",
        infoFront: "つのシナリオで使用中",
        infoRear: ""
      },
      coaterEdit: {
        h1: "名前",
        h2: "コストタイプ",
        costTypeA: "固定コスト",
        costTypeB: "ミニマムコスト ",
        fixedCost: "固定コスト",
        thCoatingType: "表面加工",
        thCoatingName: "固定コスト",
        cost: "単価／シート",
        addPaperSize: "用紙を選択",
        costPerSheet: "枚あたりコスト",
        thSheetVolume: "Sheet Volume",
        minimumCost: "ミニマムコスト",
        selectPaperSize: "用紙を選択してください",
        select: "選択してください",
        nopaper: "用紙が設定されておりません。",
        error: {
          enterGlueName: "Enter the Name.",
          tooLargeValue: "Too Large Value."
        }
      },
      routeMap: {
        notAssigned: "なし"
      }
    }
  },
  en: {
    message: {
      globalNav: {
        reflection: "Update Formula",
        calc: "Debug",
        scenario: "Scenario",
        paperSize: "Paper",
        printer: "Printer",
        coater: "Coater",
        dieCut: "Die-Cutter",
        glue: "Gluer",
        custom: "Custom",
        option: "Option",
        other: "Other"
      },
      paginator: {
        totalHead: "Total ",
        totalTail: " Items"
      },
      reflection: {
        confirmation:
          "It will change all current cost and pricing immediately.\nAre you sure you want to update?",
        completed: "Updated.",
        wait: "Please Wait"
      },
      editCommon: {
        save: "SAVE",
        saveAndBack: "SAVE & BACK",
        new: "NEW",
        saveConfirmation: "Are you sure you want to overwrite?",
        deleteConfirmation: "Are you sure you want to delete?",
        yes: "OK",
        no: "NO",
        cancel: "CANCEL",
        cause: "Cause of the Error",
        beforeUnload:
          "If you don't save yet, the data would be lost.\nAre you sure you want to leave this page?",
        error: {
          invalidSheetValue: "Invalid sheet value.",
          invalidCost: "Invalid cost.",
          unauthorized: "Email or Password is invalid.",
          error: "Error.",
          loginExpired: "Your login has expired, please login again."
        }
      },
      login: {
        h1: "Administrator Tool",
        loginButton: "LOGIN",
        logout: "LOGOUT",
        saveEmail: "Store Email & Passwprd into my browser"
      },
      scenario: {
        h1: "Scenario List",
        addScenario: "Add Item",
        routeMap: "Route Map",
        edit: "Edit",
        delete: "Delete",
        activate: "Activate",
        deactivate: "Deactivate",
        copy: "Copy Scenario",
        copied: "Copied.",
        copyConfirmation: "Can I copy it?"
      },
      scenarioEdit: {
        h1: "Scenario Edit",
        h1New: "New Scenario",
        scenarioName: "Name",
        paperSize: "Paper size",
        imposition: "Imposition",
        displayMethod: "Category",
        holderCalcType: "Paper bug holder type",
        printer: "Printer",
        coater: "Coater",
        dieCut: "Die-Cutter",
        gluer: "Gluer",
        custom: "Custom",
        margin: "Margin",
        noUpperLimit: "No Upper Limit",
        limitTo: "Limit to",
        woodenModalCalcSkip: "Wooden Cost",
        packingCostCalcSkip: "Packing Cost",
        yes: "Not skip calculation",
        no: "skip calculation",
        alertNoPaperSize: "Paper is not set.",
        linkSettingPaperSize: "Set Paper",
        linkSettingDieCut: "Set Die-Cutter",
        linkSettingGluer: "Set Gluer",
        linkSettingCoater: "Set Coater",
        linkSettingCustom: "Set Custom",
        alertNoCoater: "Coater is not set.",
        thMargin: {
          deliveryTime: "Delivery Time",
          fixedCost: "Fixed",
          rate: "Rate"
        },
        error: {
          enterScenarioName: "Enter the Name.",
          noCoater: "Coater isn't set.",
          noPaperSize: "Paper isn't set.",
          noDieCut: "Die Cut isn't set",
          noGlue: "Gluer isn't set",
          noCustom: "Custom isn't set.",
          unselectedCoater: " does not have pricing for this paper size."
        },
        success: "Succeeded."
      },
      diecut: {
        h1: "Die-Cutter",
        add: "Add Item",
        thName: "Name",
        thEdit: "Edit",
        thDelete: "Delete",
        thInfo: "Info",
        thCostType: "Cost Type",
        edit: "Edit",
        delete: "Delete",
        deleteConfirmation: "Are you sure you want to delete?",
        infoFront: "Used by ",
        infoRear: " scenario(s)"
      },
      dieCutEdit: {
        h1: "Name",
        h2: "Cost Type",
        dieCutCost: "Die Cut Cost",
        minimumCost: "Minimum Cost",
        runningCost: "Running Cost",
        runningFixFormCost: "Form Running Cost",
        costPerHour: "Cost / h",
        preparationTime: "Preparation time (mins)",
        productivityHead: "Productivity",
        productivity: "Sheet / h",
        costTypeA: "Fixed Cost",
        costTypeB: "Minimum Cost",
        costPerSheet: "Cost per Sheet",
        sheetVolume: "Sheet Volume",
        cost: "Unit Cost",
        error: {
          enterDieCutName: "Enter the Name.",
          tooLargeValue: "Too Large Value."
        }
      },
      optionEdit: {
        h1: "Option",
        foilStamping: "Foil Stamping",
        colorAdjustment: "Color Adjustment",
        sample: "Sample",
        shareOnWeb: "Share on Web",
        keepWoodenMold: "Keep Wooden Mold",
        existingWoodenMold: "Existing Wooden Mold",
        thOption: "Option",
        thCostPerMm: "Cost / ㎟",
        thFixedCost: "Fixed Cost",
        thCost: "Cost",
        thUpperDiscountCost: "Maximum discount"
      },
      otherEdit: {
        h1: "Other",
        packingParams: "Packing Cost",
        weightAllowance: "Weight allowance per carton box (kg)",
        materialCost: "material cost / carton box",
        packingCosts: "Packing Option Cost",
        deliveryCosts: "Delivery fee per carton box",
        otherCosts: "Other Cost",
        cutterLengthCosts: "Cutter cost per box shape",
        paperBugHolderCosts: "Cost per paper box shape",
        settingsRounding: "Rounding",
        settingsFixedWoodenMoldCost: "Fixed wooden mold cost",
        settingsTaxVat: "Tax / VAT",
        thPackingFee: "Option",
        thPackingFeeCostPerPack: "Cost/Pack",
        thPackingParams: "paramater",
        thPackingOption: "Area",
        thPackingCostPerPack: "Fee/Carton box",
        thOther: "Other",
        thBoxShape: "Box shape",
        thcoefficientPricePercm: "coefficient * price / cm",
        thUnitA: "UnitA",
        thUnitB: "UnitB",
        thRounding: "rounding to the"
      },
      custom: {
        h1: "Custom",
        add: "Add Item",
        thName: "Name",
        thEdit: "Edit",
        thDelete: "Delete",
        thInfo: "Info",
        thCostType: "Cost Type",
        edit: "Edit",
        delete: "Delete",
        infoFront: "Used by ",
        infoRear: " scenario(s)"
      },
      customEdit: {
        customName: "Name",
        description: "Description",
        costType: "Cost Type",
        costTypeFixed: "Fixed Cost",
        costTypeMinimum: "Minimum Cost",
        thFixedCost: "Fixed Cost",
        thMinimumCost: "Minimum Cost",
        selectUnit: "Unit Type",
        buffer: "Unit Cost",
        thVolume: "Volume",
        thUnitCost: "Unit Cost",
        margin: "Margin",
        unitLabels: {
          quantity: "Quantity",
          sheet: "Sheet",
          impression: "Impression",
          areaSize: "Area Size (cm2)",
          imposition: "Imposition"
        },
        marginLabels: {
          notApply: "Not applicable",
          apply: "Applicable"
        }
      },
      paperSize: {
        h1: "Paper",
        add: "Add Item",
        thName: "Paper",
        thWidth: "Width",
        thDimension: "Depth",
        thUnprintableWidth: "Unprintable Area W",
        thUnprintableDimension: "Unprintable Area D",
        thInfo: "Info",
        thCoaterInfo: "Coater",
        edit: "Edit",
        delete: "Delete",
        infoFront: "Used by ",
        infoRear: " scenario(s)",
        infoCoater: "used in coaters.",
        infoCoaterUsed: "Set",
        infoCoaterUnused: "Not Set"
      },
      paperCost: {
        h2: "Paper Cost / Sheet",
        paperType: "Paper Name",
        fixedCost: "Fixed Cost"
      },
      glue: {
        h1: "Gluer",
        add: "Add Item",
        thName: "Name",
        thEdit: "Edit",
        thDelete: "Delete",
        thInfo: "Info",
        thCostType: "Cost Type",
        edit: "Edit",
        delete: "Delete",
        infoFront: "Used by ",
        infoRear: " scenario(s)"
      },
      glueEdit: {
        h1: "Name",
        h2: "Cost Type",
        glueCost: "Fixed Cost",
        minimumCost: "Minimum Cost",
        runningCost: "Cost per Price",
        costPerHour: "Cost / h",
        preparationTime: "Preparation time (mins)",
        productivityBS: "Productivity by Box Shape",
        machineBoxUnitCost: "PaperBug UnitCost",
        thBoxShape: "Box Shape",
        thQuantity: "Quantity / h",
        thUnitCost: "Unit Cost",
        costTypeA: "Fixed Cost",
        costTypeB: "Minimum Cost",
        manualGlue: "Manual Glue",
        sheetVolume: "Quantity",
        cost: "Cost",
        error: {
          enterGlueName: "Enter the Name.",
          tooLargeValue: "Too Large Value."
        }
      },
      printer: {
        h1: "Printer",
        add: "Add Item",
        thName: "Name",
        thEdit: "Edit",
        thDelete: "Delete",
        thInfo: "Info",
        thCostType: "Cost Type",
        edit: "Edit",
        delete: "Delete",
        infoFront: "Used by ",
        infoRear: " scenario(s)"
      },
      printerEdit: {
        h1: "Name",
        costType: "Cost Type",
        fixedCost: "Fixed Cost",
        costTypeA: "Fixed Cost (Inkjet)",
        costTypeB: "Fixed Cost (Dry Ink)",
        costTypeC: "Minimum Cost",
        sheetVolume: "Sheet Volume",
        thCost: "Cost / h",
        thPreparationTIme: "Preparation Time (mins)",
        buffer: "Buffer",
        printSpeed: "Print Speed",
        thPrintSpeed: "Sheet / h",
        inkCost: "Ink Cost",
        thCostForMaxSize: "Cost for Max Size",
        thMaxSizeW: "Max Size W",
        thMaxSizeD: "Max Size D",
        proofing: "Proofing",
        threeDWeb: "3D Web",
        actualProofing: "Actual Proofing",
        cost: "Cost",
        minimumCost: "Minimum Cost",
        plateCost: "Plate Cost",
        ctp: "Cost / Plate",
        printCost: "Print Cost (Cost per Sheet / Color)",
        costPerSheet: "Cost per Sheet / Color",
        costPerImpression: "Cost per Impression",
        unitCost: "Unit Cost",
        error: {
          enterDieCutName: "Enter the Name.",
          tooLargeValue: "Too Large Value."
        }
      },
      coater: {
        h1: "Coater",
        add: "Add Item",
        thName: "Name",
        thEdit: "Edit",
        thDelete: "Delete",
        thInfo: "Info",
        thCostType: "Cost Type",
        edit: "Edit",
        delete: "Delete",
        infoFront: "Used by ",
        infoRear: " scenario(s)"
      },
      coaterEdit: {
        h1: "Name",
        h2: "Cost Type",
        costTypeA: "Fixed",
        costTypeB: "Minimum",
        fixedCost: "Fixed Cost",
        thCoatingType: "Coating Type",
        thCoatingName: "Fixed Cost",
        cost: "Unit Cost",
        addPaperSize: "Select Paper",
        costPerSheet: "Cost per Sheet",
        thSheetVolume: "Sheet Volume",
        minimumCost: "Minimum Cost",
        selectPaperSize: "Select Paper",
        select: "Select",
        nopaper: "There is no paper",
        error: {
          enterGlueName: "Enter the Name.",
          tooLargeValue: "Too Large Value."
        }
      },
      routeMap: {
        notAssigned: "Not Assigned"
      }
    }
  }
};
